import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

const BlogGridSkeleton = ({ count = 3, className = "", rowClassName = "allCategory" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`mt-3 row ${rowClassName} ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingBlogs")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingBlogs")}</span>
      {Array.from({ length: count }, (_, index) => (
        <div className="col-md-4" key={`blog-skeleton-${index}`}>
          <div className="shimmer-cont skeleton-surface p-2">
            <div className="shimmer-header d-flex">
              <div className="shimmer-title ms-1 w-100">
                <ShimmerTitle line={2} gap={8} />
              </div>
            </div>
            <div className="square-shimmer mt-2">
              <ShimmerDiv height={180} width="100%" rounded={8} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogGridSkeleton;
